import type { WorkflowRunDocumentPayload } from '@Application/WorkflowRuns/WorkflowRun/Actions/workflowRunFetched';
import type { LabeledValuePayload } from '@Application/Users/UserStatuses/Actions/userStatusesFetched';

/** One row of `GET …/workflow-runs`, most recently opened first. `startedAt` is meaningless while `state.value === 'open'`. */
export type WorkflowRunSummaryPayload = {
	readonly id: number;
	readonly workflowKey: string;
	readonly label: string;
	readonly kind: LabeledValuePayload;
	readonly state: LabeledValuePayload;
	readonly openedAt: string;
	readonly startedAt: string;
	readonly completedAt: string | null;
	readonly isGenerating: boolean;
	readonly handledAt: string | null;
	readonly documents: readonly WorkflowRunDocumentPayload[];
};

export type BeneficiaryWorkflowRunsFetchedPayload = {
	readonly totalRecords: number;
	readonly results: readonly WorkflowRunSummaryPayload[];
};

export type BeneficiaryWorkflowRunsFetchedAction = {
	type: 'BENEFICIARY_WORKFLOW_RUNS_FETCHED';
	payload: BeneficiaryWorkflowRunsFetchedPayload;
	facilityId: number;
	subjectId: number;
	typeKey: string;
};

export default (
	payload: BeneficiaryWorkflowRunsFetchedPayload,
	facilityId: number,
	subjectId: number,
	typeKey: string,
): BeneficiaryWorkflowRunsFetchedAction => ({
	type: 'BENEFICIARY_WORKFLOW_RUNS_FETCHED',
	payload,
	facilityId,
	subjectId,
	typeKey,
});
